import { useState, useEffect, useRef } from "react";
import { CommentServices } from "../services/CommentServices";
import { getUser, logOut } from "../config/user";
import { useSelector, useDispatch } from "react-redux";
import SpeakerIcon from "../assets/speakerIcon.svg";
import CcChatCheck from "../assets/CcChatCheck.svg";
import HighRiskText from "../assets/HighRiskText.svg";
import CallIcon from "../assets/call filled.svg";
import SendIcon from "../assets/sendIcon.svg";
import SpeechToText from "../assets/speechToText.svg";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { fetchCommentCount } from "../redux/notificationSlice";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const DocCommentDetails = ({ documentId, commentOn }) => {
  const [docDetails, setDocDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [message, setMessage] = useState("");
  const [ccChecked, setCcChecked] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [openRiskModal, setOpenRiskModal] = useState(false);
  const dispatch = useDispatch();
  const { messageId } = useSelector((store) => store.notificationReducer);
  const endOfMessagesRef = useRef(null);
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  const user = getUser();
  const getUsers = async () => {
    try {
      const res = await CommentServices.getAllUserDetail();
      setUsers(res?.data?.users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const updateViewDetail = async () => {
    try {
      const res = await CommentServices.updateViewDetail({
        documentId: documentId,
        commentOn: commentOn,
      });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDocComments = async () => {
    try {
      const res = await CommentServices.getDocumentComments(
        commentOn,
        documentId,
      );
      setDocDetails(res?.data?.documentDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleReadCcCommentNotification = async (documentId) => {
    // users[comment.from].role?.toLowerCase()?.includes("hospital");
    let comment =
      docDetails?.comments?.length > 0
        ? docDetails?.comments[docDetails?.comments?.length - 1]
        : null;
    if (
      !comment ||
      !users[comment.from].role?.toLowerCase()?.includes("hospital")
    ) {
      return;
    }
    try {
      //read all the notification of cc user
      if (user?.roles[0]?.roleId !== 1 && user?.roles[0]?.roleId !== 2) {
        await CommentServices.readDocCommentNotification(documentId);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCommentAdd = async () => {
    if (message) {
      try {
        const commentData = {
          documentId: documentId,
          message: message,
          commentOn: commentOn,
        };
        const res = await CommentServices.sendComment(commentData);
        setMessage("");
        // await referenceContext.getMappedDocuments();
        await getDocComments(commentOn, documentId);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }
  };
  const handleRiskCommentAdd = async (riskData) => {
    try {
      let userInput = prompt("Enter Procedure Code that HSA suggested.");
      if (userInput) {
        const commentData = {
          documentId: documentId,
          message: riskData.message + `(code: ${userInput})`,
          procedureCode: userInput,
          riskResponse: riskData?.riskResponse,
          riskType: riskData?.riskType,
          commentOn: commentOn,
        };
        await CommentServices.sendComment(commentData);
        await handleReadCcCommentNotification(documentId);
        await getDocComments();
      }
      setOpenRiskModal(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCodeCommentAdd = async (message, comment) => {
    try {
      const commentData = {
        documentId: documentId,
        message: comment ? message + ` ${comment?.procedureCode}` : message,
        commentOn: commentOn,
      };
      await CommentServices.sendComment(commentData);
      await handleReadCcCommentNotification(documentId);
      setOpenRiskModal(false);
      await getDocComments();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCallButtonClick = async () => {
    const text = `Welcome to Settlemed!
Thank you for reaching out. Your call request has been received.
We appreciate your patience—our Command Centre team will get back to you shortly via the Settlemed mobile application.

If you haven’t downloaded the app yet, please do so to stay connected and ensure smooth communication.`;

    try {
      const commentData = {
        documentId: documentId,
        message: "Kindly give me a call back at your earliest convenience",
        commentOn: commentOn,
      };
      await CommentServices.sendComment(commentData);

      await getDocComments();

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-US";
      utterance.rate = 1.5;

      const voices = window.speechSynthesis.getVoices();

      // Select a female English voice (e.g., Google or Microsoft voices)
      const femaleVoice = voices.find(
        (voice) =>
          (voice.lang === "en-US" && /female|woman/i.test(voice.name)) ||
          /Google US English/i.test(voice.name),
      );

      if (femaleVoice) {
        utterance.voice = femaleVoice;
      }

      window.speechSynthesis.speak(utterance);
      window.alert(text);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleCCfilter = async () => {
    if (ccChecked) {
      setCcChecked(false);
      await getDocComments();
    } else {
      const filteredComments = docDetails.comments?.filter(
        (comment) =>
          !users[comment.from].role?.toLowerCase()?.includes("hospital"),
      );
      docDetails.comments = filteredComments;
      setDocDetails({ ...docDetails });
      setCcChecked(true);
    }
  };
  const markReadNotification = async () => {
    try {
      const res = await CommentServices.markNotificationReadByDocId(documentId);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  // const handleSpeak = (text) => {
  //   if (text !== "") {
  //     const utterance = new SpeechSynthesisUtterance(text);
  //     window.speechSynthesis.speak(utterance);
  //   }
  // };

  const [currentCommentId, setCurrentCommentId] = useState(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(-1);

  const handleSpeak = (text, commentId) => {
    if (!window.speechSynthesis) {
      alert("Speech Synthesis not supported in your browser");
      return;
    }

    // Cancel any ongoing speech
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1;

    const words = text.split(/\s+/);
    setCurrentCommentId(commentId);
    setCurrentWordIndex(-1);

    utterance.onboundary = (event) => {
      if (event.name === "word") {
        const charIndex = event.charIndex;
        let currentCharCount = 0;

        for (let i = 0; i < words.length; i++) {
          currentCharCount += words[i].length + (i < words.length - 1 ? 1 : 0);

          if (charIndex < currentCharCount) {
            setCurrentWordIndex(i);
            break;
          }
        }
      }
    };

    utterance.onend = () => {
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    utterance.onerror = (event) => {
      console.error("SpeechSynthesis error:", event);
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    window.speechSynthesis.speak(utterance);
  };

  const stopSpeaking = () => {
    window.speechSynthesis.cancel();
    setCurrentWordIndex(-1);
    setCurrentCommentId(null);
  };

  // Clean up on component unmount
  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
    };
  }, []);
  const getFormattedDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Convert to 12-hour format with AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Hour '0' should be '12'

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };
  useEffect(() => {
    getUsers();
  }, []);
  useEffect(() => {
    getDocComments();
    markReadNotification();
    dispatch(fetchCommentCount());
  }, [messageId]);
  useEffect(() => {
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.continuous = true; // Keep listening until stopped
      recognition.interimResults = true; // Show interim results

      recognition.onresult = (event) => {
        let currentTranscript = "";
        for (let i = event.resultIndex; i < event.results.length; i++) {
          currentTranscript += event.results[i][0].transcript;
        }
        setTranscript(currentTranscript);
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error", event.error);
      };

      // Start/Stop Listening
      if (isListening) {
        recognition.start();
      } else {
        recognition.stop();
      }

      // Cleanup on component unmount
      return () => recognition.stop();
    } else {
      alert("Speech Recognition API not supported in this browser.");
    }
  }, [isListening]);
  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
    updateViewDetail();
  }, [docDetails]);

  return (
    <div>
      {docDetails && (
        <div className="w-fit text-[30px] 2xl:text-[50px] leading-[65.26px] -tracking-[7%]  mt-[12px] 2xl:mt-[30px]">
          {commentOn === "REFERENCEDOCUMENT"
            ? docDetails?.description
            : docDetails?.documentlistmaster?.documentName}
        </div>
      )}
      <div
        id="case-list"
        style={{ background: "rgba(255,255,255,0.5)" }}
        className="p-4 2xl:p-8 mt-1 2xl:mt-4 rounded-[30px] min-h-[70vh]"
      >
        {docDetails && (
          <div>
            <div className="flex justify-center items-cnter">
              <img
                src={docDetails?.documentUrl}
                alt="docc-image"
                className="rounded-[30px] max-w-full "
              />
            </div>
            <div
              style={{ border: "1px solid #F0F0F0", boxSizing: "border-box" }}
              className="relative h-[70vh] rounded-[30px] bg-[#FFFFFFA1] p-2 mt-6"
            >
              <div
                style={{ boxSizing: "border-box" }}
                className="absolute top-0 left-0 w-full bg-white flex justify-between items-center px-[10px] py-[16px] mb-2 rounded-t-[30px] z-1"
              >
                <div className="text-[24px] text-[#191919] font-medium">
                  Chat box ({docDetails && (docDetails?.comments?.length || 0)})
                </div>
                <div className="flex  items-center gap-[10px] mr-6">
                  {/* <input
                  type="checkbox"
                  onClick={handleCCfilter}
                  className="h-[16px] w-[16px]"
                />
                <div className="text-[#017C71]">CC Chat</div> */}
                  <img
                    src={CallIcon}
                    alt="call-icon"
                    className="cursor-pointer"
                    onClick={handleCallButtonClick}
                  />
                </div>
              </div>
              <div className="h-[72%] 2xl:h-[82%] flex flex-col  overflow-y-scroll mt-12 ">
                {docDetails &&
                  docDetails?.comments?.map((comment, idx) => {
                    return (
                      <div key={idx}>
                        {" "}
                        {user?.user?.id === comment?.from ? (
                          <div key={idx} className="flex justify-end mt-[10px]">
                            <div className="max-w-[75%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#dcf8c6] rounded-[20px]">
                              <div className="flex items-center justify-between">
                                <div className="flex flex-row-reverse  items-center  gap-[10px] ">
                                  <div className="w-[33px] h-[33px]  flex justify-center items-center text-[#0B0B0B] text-[20px] bg-white rounded-full">
                                    U
                                  </div>
                                  <div className="text-[15px] font-medium ">
                                    You
                                  </div>
                                </div>
                                <div className="flex items-center gap-[20px] px-[10px]">
                                  <div className="text-[10px] text-[#969696]">
                                    {getFormattedDate(comment.createdAt)}
                                    <DoneAllOutlinedIcon
                                      style={{
                                        color:
                                          comment?.views?.length >=
                                          comment?.to?.length
                                            ? "#00ccff"
                                            : "",
                                        fontSize: "14px",
                                        marginLeft: "8px",
                                      }}
                                    />
                                  </div>
                                  {/* <div>
                                    <img
                                      src={SpeakerIcon}
                                      alt="speaker-icon"
                                      className="cursor-pointer"
                                      onClick={() =>
                                        handleSpeak(comment?.message)
                                      }
                                    />
                                  </div> */}
                                  <div>
                                    <img
                                      src={SpeakerIcon}
                                      alt="speaker-icon"
                                      className="cursor-pointer w-4 h-4" // Added explicit dimensions
                                      onClick={() =>
                                        handleSpeak(comment.message, idx)
                                      }
                                      onKeyDown={(e) =>
                                        e.key === "Enter" &&
                                        handleSpeak(comment.message, idx)
                                      } // Added keyboard accessibility
                                      role="button" // Added for accessibility
                                      tabIndex={0} // Added for keyboard navigation
                                    />
                                  </div>
                                </div>
                              </div>
                              {comment?.riskType ? (
                                <div className="flex gap-2 items-start  mt-3">
                                  <div className="w-[40%]">
                                    <img
                                      src={HighRiskText}
                                      alt="high-risk-text-icon"
                                      className="w-full h-auto object-contain"
                                    />
                                  </div>
                                  <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px]">
                                    {comment?.message.split(/\s+/).map(
                                      (
                                        word,
                                        wordIdx, // Changed to split(/\s+/) and renamed idx to wordIdx
                                      ) => (
                                        <span
                                          key={wordIdx}
                                          style={{
                                            backgroundColor:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "yellow"
                                                : "transparent",
                                            transition:
                                              "background-color 0.2s ease", // Added smooth transition
                                            marginRight: "4px",
                                            borderRadius:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "4px"
                                                : "0",
                                            padding:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "0 2px"
                                                : "0",
                                          }}
                                          aria-live={
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "polite"
                                              : "off"
                                          }
                                        >
                                          {word}
                                        </span>
                                      ),
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px] mt-3">
                                  {comment?.message.split(/\s+/).map(
                                    (
                                      word,
                                      wordIdx, // Changed to split(/\s+/) and renamed idx to wordIdx
                                    ) => (
                                      <span
                                        key={wordIdx}
                                        style={{
                                          backgroundColor:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "yellow"
                                              : "transparent",
                                          transition:
                                            "background-color 0.2s ease", // Added smooth transition
                                          marginRight: "4px",
                                          borderRadius:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "4px"
                                              : "0",
                                          padding:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "0 2px"
                                              : "0",
                                        }}
                                        aria-live={
                                          currentCommentId === idx &&
                                          wordIdx === currentWordIndex
                                            ? "polite"
                                            : "off"
                                        }
                                      >
                                        {word}
                                      </span>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-start mt-[10px]">
                            <div className="max-w-[87%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#F4F4F4] rounded-[20px]">
                              <div className=" flex items-center justify-between">
                                <div className="flex items-center  gap-[10px] ">
                                  <div className="w-[33px] h-[33px]  flex justify-center items-center uppercase text-white text-[20px] bg-[#8B8B8B] rounded-full">
                                    {user?.roles[0]?.roleId === 1 ||
                                    user?.roles[0]?.roleId === 2
                                      ? users && users[comment?.from].userName
                                        ? users[comment?.from].userName[0]
                                        : "U"
                                      : users && users[comment?.from].fullName
                                        ? users[comment?.from].fullName[0]
                                        : "U"}
                                  </div>
                                  <div className="text-[15px] font-medium ">
                                    {user?.roles[0]?.roleId === 1 ||
                                    user?.roles[0]?.roleId === 2
                                      ? users && users[comment?.from].userName
                                        ? users[comment?.from].userName
                                        : "Unknown"
                                      : users && users[comment?.from].fullName
                                        ? users[comment?.from].fullName
                                        : "Unknown"}
                                  </div>
                                  {users &&
                                    !users[comment.from]?.role
                                      ?.toLowerCase()
                                      .includes("hospital") && (
                                      <div className="text-[10px] text-white px-2 py-1 rounded-full bg-[#017C71]">
                                        CC
                                      </div>
                                    )}
                                </div>
                                <div>
                                  <div className="flex items-center justify-between px-[10px]">
                                    <div className="text-[10px] text-[#969696]">
                                      {getFormattedDate(comment.createdAt)}
                                    </div>
                                    <div>
                                      <img
                                        src={SpeakerIcon}
                                        alt="speaker-icon"
                                        className="cursor-pointer w-4 h-4"
                                        onClick={() =>
                                          handleSpeak(comment.message, idx)
                                        }
                                        onKeyDown={(e) =>
                                          e.key === "Enter" &&
                                          handleSpeak(comment.message, idx)
                                        }
                                        role="button"
                                        tabIndex={0}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {comment?.riskType ? (
                                <div>
                                  <div className="flex gap-2 items-start  mt-3">
                                    <div className="w-[40%]">
                                      <img
                                        src={HighRiskText}
                                        alt="high-risk-text-icon"
                                        className="w-full h-auto object-contain"
                                      />
                                    </div>
                                    <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px]">
                                      {comment?.message.split(/\s+/).map(
                                        (
                                          word,
                                          wordIdx, // Changed to split(/\s+/) and renamed idx to wordIdx
                                        ) => (
                                          <span
                                            key={wordIdx}
                                            style={{
                                              backgroundColor:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "yellow"
                                                  : "transparent",
                                              transition:
                                                "background-color 0.2s ease", // Added smooth transition
                                              marginRight: "4px",
                                              borderRadius:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "4px"
                                                  : "0",
                                              padding:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "0 2px"
                                                  : "0",
                                            }}
                                            aria-live={
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "polite"
                                                : "off"
                                            }
                                          >
                                            {word}
                                          </span>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                  {/* buttons */}
                                  <div className="flex justify-center items-center gap-3 text-[10px]">
                                    <div
                                      className="uppercase bg-[#017C57] text-white px-5 py-2 rounded-full"
                                      onClick={() =>
                                        handleCodeCommentAdd(
                                          "PLEASE PROCEED WITH EXISTING CODE",
                                          comment,
                                        )
                                      }
                                    >
                                      Proceed with existing code
                                    </div>
                                    <div
                                      className="uppercase bg-[#017C57] text-white px-5 py-2 rounded-full"
                                      onClick={() =>
                                        handleCodeCommentAdd(
                                          "PLEASE GET BEST SUITABLE CODE",
                                        )
                                      }
                                    >
                                      GET BEST SUITABLE CODE
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px] mt-3">
                                  {comment?.message.split(/\s+/).map(
                                    (
                                      word,
                                      wordIdx, // Changed to split(/\s+/) and renamed idx to wordIdx
                                    ) => (
                                      <span
                                        key={wordIdx}
                                        style={{
                                          backgroundColor:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "yellow"
                                              : "transparent",
                                          transition:
                                            "background-color 0.2s ease", // Added smooth transition
                                          marginRight: "4px",
                                          borderRadius:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "4px"
                                              : "0",
                                          padding:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "0 2px"
                                              : "0",
                                        }}
                                        aria-live={
                                          currentCommentId === idx &&
                                          wordIdx === currentWordIndex
                                            ? "polite"
                                            : "off"
                                        }
                                      >
                                        {word}
                                      </span>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        <div ref={endOfMessagesRef} />
                      </div>
                    );
                  })}
              </div>
              <div className="absolute bottom-1 left-0 w-full flex justify-center bg-white z-1 bg-transparent rounded-full">
                <div
                  style={{
                    border: "1px solid #EAEAEA",
                    boxSizing: "border-box",
                  }}
                  className="w-[98%] mx-auto flex items-center justify-between p-1 rounded-full bg-white"
                >
                  <textarea
                    placeholder="Type a message..."
                    className="w-[80%] text-[#555] font-semibold outline-none border-none ml-2 resize-none overflow-auto max-h-[300px] bg-transparent"
                    value={message}
                    rows={1}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey && message.trim()) {
                        e.preventDefault(); // Prevents newline on Enter without Shift
                        handleCommentAdd();
                      }
                    }}
                  />
                  <div className="flex items-center gap-1">
                    <img
                      src={SpeechToText}
                      alt="speech-to-text-icon"
                      onClick={() => setIsListening(!isListening)}
                    />
                    <img
                      src={SendIcon}
                      alt="send-icon"
                      onClick={handleCommentAdd}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocCommentDetails;
